"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = create;
exports.findAll = findAll;
exports.remove = remove;
exports.update = update;
var _request = _interopRequireDefault(require("@/utils/request"));
function findAll(listQuery) {
  return (0, _request.default)({
    url: "/foods",
    method: "get",
    params: listQuery
  });
}
function create(data) {
  return (0, _request.default)({
    url: "/foods",
    method: "post",
    data: data
  });
}
function update(foodId, data) {
  return (0, _request.default)({
    url: "/foods/".concat(foodId, "/update"),
    method: "post",
    data: data
  });
}
function remove(foodId) {
  return (0, _request.default)({
    url: "/foods/".concat(foodId, "/delete"),
    method: "post"
  });
}